import { Tooltip } from '@mantine/core';
import {
  Icon,
  IconBell,
  IconConfetti,
  IconFileText,
  IconHammer,
  IconKey,
  IconNote,
  IconTool,
} from '@tabler/icons-react';
import type { ForwardRefExoticComponent, RefAttributes } from 'react';

import type { EventVisualIcon } from 'src/Utils/eventVisuals';

import styles from './SameDayEvent.module.scss';
import { Props } from './SameDayEvent.types';

type TablerIconComponent = ForwardRefExoticComponent<
  React.ComponentProps<typeof IconNote> & RefAttributes<Icon>
>;

const ICON_COMPONENTS: Record<EventVisualIcon, TablerIconComponent> = {
  IconTool,
  IconHammer,
  IconKey,
  IconFileText,
  IconConfetti,
  IconNote,
  IconBell,
};

const SameDayEvent = ({
  showHour,
  topPx,
  name,
  hour,
  onClick,
  description,
  icon,
  accentColor,
}: Props) => {
  const IconComponent = ICON_COMPONENTS[icon];
  const tooltipLabel = name + (description ? ` (${description})` : '');

  return (
    <Tooltip
      label={tooltipLabel}
      transitionProps={{ transition: 'fade-up', duration: 300 }}
      disabled={!description}
      openDelay={500}
    >
      <div
        className={styles.sameDayEvent}
        style={{
          top: `${topPx}px`,
          borderColor: accentColor,
        }}
        onClick={e => {
          e.stopPropagation();
          onClick();
        }}
      >
        <IconComponent size={12} stroke={1.75} />
        <div className={styles.sameDayEventName}>{tooltipLabel}</div>
        {showHour && <div className={styles.sameDayEventStartHour}>{hour}</div>}
      </div>
    </Tooltip>
  );
};

export default SameDayEvent;
